import { render, staticRenderFns } from "./BirdVector.vue?vue&type=template&id=29144b26&"
import script from "./BirdVector.vue?vue&type=script&lang=js&"
export * from "./BirdVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports